import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'terracotta' | 'paper';
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  variant = 'terracotta',
  href = '#offre'
}: CTAButtonProps) {
  const colors = variant === 'terracotta' ? 'bg-brand-terracotta text-brand-slate hover:bg-[#cd7a63] focus-visible:ring-brand-terracotta' : 'bg-white text-brand-slate hover:bg-brand-sand focus-visible:ring-white';
  return <a href={href} className={`cta-attention inline-flex items-center justify-center gap-2 rounded-full px-8 py-4 text-sm font-extrabold tracking-wide shadow-md transition-[colors,box-shadow] duration-200 ease-out hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 md:text-base ${colors} ${className}`} data-id="element-46" data-mp="2ozqgbkiyf39z">
      {children}
      <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-47" data-mp="38pa9jmmk62ww" />
    </a>;
}